import { and, eq, isNotNull } from "drizzle-orm";
import { importOrderLines } from "@/server/platform/db/schema/inventory";

/** ใช้ใน SQL subquery ที่อ้าง alias `import_order_lines` */
export const MATCHED_IMPORT_LINE_SQL =
  "import_order_lines.match_status = 'matched' AND import_order_lines.variant_id IS NOT NULL";

export function isMatchedImportLine(line: {
  matchStatus: string;
  variantId: string | null;
}): boolean {
  return line.matchStatus === "matched" && line.variantId != null;
}

export function matchedImportLineWhere() {
  return and(
    eq(importOrderLines.matchStatus, "matched"),
    isNotNull(importOrderLines.variantId),
  );
}

export function importLineInTransitRemaining(line: {
  matchStatus: string;
  variantId: string | null;
  orderedQuantity: number;
  receivedQuantity: number;
  shortQuantity: number;
}): number {
  if (!isMatchedImportLine(line)) return 0;
  return Math.max(
    0,
    line.orderedQuantity - line.receivedQuantity - line.shortQuantity,
  );
}

export function importLineInTransitValueLak(line: {
  matchStatus: string;
  variantId: string | null;
  orderedQuantity: number;
  receivedQuantity: number;
  shortQuantity: number;
  unitLandedCostLak: string | number;
}): number {
  const remaining = importLineInTransitRemaining(line);
  if (remaining <= 0) return 0;
  return remaining * Number(line.unitLandedCostLak);
}
